'use client';

import { useFormContext } from 'react-hook-form';

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import type { SaleApplicationData } from '@/features/original-sale';
import { cn } from '@/lib/utils';

export const SaleBankFields = () => {
  const { control } = useFormContext<SaleApplicationData>();

  return (
    <div className="space-y-4">
      <FormField
        control={control}
        name="bankName"
        render={({ field, fieldState }) => (
          <FormItem>
            <FormLabel className={cn('font-normal', !fieldState.error && 'text-[#888C91]')}>
              Наименование вашего банка
              <span>*</span>
            </FormLabel>
            <FormControl>
              <Input
                className="h-10 font-medium"
                placeholder="Введите название вашего банка"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="bankAccount"
        render={({ field, fieldState }) => (
          <FormItem>
            <FormLabel className={cn('font-normal', !fieldState.error && 'text-[#888C91]')}>
              Номер банковского счета получателя
              <span>*</span>
            </FormLabel>
            <FormControl>
              <Input className="h-10 font-medium" placeholder="Номер счёта получателя" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="bik"
        render={({ field, fieldState }) => (
          <FormItem>
            <FormLabel className={cn('font-normal', !fieldState.error && 'text-[#888C91]')}>
              БИК банка<span>*</span>
            </FormLabel>
            <FormControl>
              <Input
                className="h-10 font-medium"
                placeholder="Введите БИК вашего банка"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="recipientFullName"
        render={({ field, fieldState }) => (
          <FormItem>
            <FormLabel className={cn('font-normal', !fieldState.error && 'text-[#888C91]')}>
              ФИО получателя<span>*</span>
            </FormLabel>
            <FormControl>
              <Input className="h-10 font-medium" placeholder="Иванов Иван Иванович" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="recipientInn"
        render={({ field, fieldState }) => (
          <FormItem>
            <FormLabel className={cn('font-normal', !fieldState.error && 'text-[#888C91]')}>
              ИНН получателя<span>*</span>
            </FormLabel>
            <FormControl>
              <Input className="h-10 font-medium" placeholder="Введите ИНН получателя" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
